import {useEffect,type RefObject} from "react";
import type {AssistanceMessage} from "./accountApi";
export const unreadMessages=(messages:AssistanceMessage[])=>messages.filter(m=>m.sender==="WORKSHOP"&&!m.readAt);
export const chatReadCopy={pt:"Mensagens por ler",de:"Ungelesene Nachrichten",en:"Unread messages",fr:"Messages non lus",it:"Messaggi non letti"};
export const chatUiCopy={
 pt:{title:"Mensagens",loading:"A atualizar as conversas…",empty:"Ainda não existem conversas com a oficina.",open:"Toque para abrir a conversa.",customer:"Você"},
 de:{title:"Nachrichten",loading:"Gespräche werden aktualisiert…",empty:"Noch keine Gespräche mit der Werkstatt.",open:"Tippen, um das Gespräch zu öffnen.",customer:"Sie"},
 en:{title:"Messages",loading:"Refreshing conversations…",empty:"No conversations with the workshop yet.",open:"Tap to open the conversation.",customer:"You"},
 fr:{title:"Messages",loading:"Actualisation des conversations…",empty:"Aucune conversation avec l’atelier.",open:"Touchez pour ouvrir la conversation.",customer:"Vous"},
 it:{title:"Messaggi",loading:"Aggiornamento delle conversazioni…",empty:"Nessuna conversazione con l’officina.",open:"Tocca per aprire la conversazione.",customer:"Tu"}
};

// Opening an inbox does not imply reading: acknowledge only messages visible for a second.
export function useVisibleMessageReads(rootRef:RefObject<HTMLDivElement|null>,open:boolean,signature:string,onRead:(ids:string[])=>Promise<void>){
 useEffect(()=>{
  const root=rootRef.current;if(!open||!root)return;
  let active=true,busy=false,retries=0;
  const visible=new Map<string,number>(),sent=new Set<string>();
  const observer=new IntersectionObserver(entries=>{for(const e of entries){
   const id=(e.target as HTMLElement).dataset.messageId!;
   if(e.isIntersecting&&(e.intersectionRatio>=.65||e.intersectionRect.height>=240)){if(!visible.has(id))visible.set(id,Date.now());}
   else visible.delete(id);
  }},{root,threshold:[0,.1,.3,.65,1]});
  root.querySelectorAll<HTMLElement>('[data-message-id][data-unread="true"]').forEach(e=>observer.observe(e));
  const timer=setInterval(()=>{
   if(!active||busy||retries>=3||document.visibilityState!=="visible")return;
   const ids=[...visible].filter(([id,since])=>!sent.has(id)&&Date.now()-since>=1000).map(([id])=>id).slice(0,100);
   if(!ids.length)return;
   busy=true;ids.forEach(id=>sent.add(id));
   void onRead(ids).catch(()=>{retries++;ids.forEach(id=>{sent.delete(id);if(visible.has(id))visible.set(id,Date.now()+4000);});}).finally(()=>{busy=false;});
  },300);
  const visibility=()=>{visible.forEach((_,id)=>visible.set(id,Date.now()));};
  document.addEventListener("visibilitychange",visibility);
  return()=>{active=false;observer.disconnect();clearInterval(timer);document.removeEventListener("visibilitychange",visibility);};
 },[rootRef,open,signature,onRead]);
}
